import React from 'react'
import ProfileContainer from '../../containers/admin_portal/profile';
const MyProfile = () => {
  return (
    <div>
      <ProfileContainer/>
    </div>
  )
} 

export default MyProfile;
